import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';

export type LogLevel = 'Warning' | 'Error' | 'Fatal';

export interface AppLogDto {
  id:            string;
  loggedAt:      string;
  level:         string;
  message:       string;
  exception:     string | null;
  correlationId: string | null;
  sourceContext: string | null;
  machineName:   string | null;
  requestPath:   string | null;
}

export interface SystemLogFilter {
  level?:         string;
  search?:        string;
  correlationId?: string;
  fromDate?:      string;
  toDate?:        string;
  pageNumber?:    number;
  pageSize?:      number;
}

export const systemLogsApi = {
  /** GET /api/v1/system-logs — warning-and-above application log, newest first. */
  getList: (filter?: SystemLogFilter) =>
    apiClient.get<ApiResponse<PagedResult<AppLogDto>>>('/system-logs', { params: filter }),
};
